export const agroGroupModel = {
    label: 'Groupe agroforesterie',
    tableName: 'agroGroups',
    properties: [
        {
            label: 'Site',
            id: 'village',
            isForeignKey: true,
            column_name: 'name',
            table_column: 'parent',
            type: 'text',
            example: 'Antsahampano', // Nom du village/site de rattachement
            required: true
        },
        {
            label: 'Nom',
            id: 'name',
            type: 'text',
            example: 'AGRO-DIANA-001', // Identifiant ou nom du groupe
            required: true
        }
    ]
}
